import { TimesheetLinesByDate, TimesheetLinesByMonth } from '../../../domain/timesheets-domain';
import dayjs from 'dayjs';

// creates an array of group timesheet lines by month
export function groupTimesheetLinesByMonth(timesheetLines: TimesheetLinesByDate[]) {
  return timesheetLines.reduce((timesheetLineMonthAccumulator: TimesheetLinesByMonth[], currentValue) => {
    const parsedDate = dayjs(currentValue.date, 'YYYY-MM-DD').startOf('day');
    const month = parsedDate.format('MMMM');
    const year = parsedDate.format('YYYY');
    const isSameMonth = timesheetLineMonthAccumulator.find((timesheetMonth) => timesheetMonth.month === month && timesheetMonth.year == year);
    if (isSameMonth)
      return timesheetLineMonthAccumulator.map((timesheetMonth) => {
        if (timesheetMonth.month === month && timesheetMonth.year == year) {
          return { ...timesheetMonth, totalHours: timesheetMonth.totalHours + currentValue.totalHours, timesheetLinesByDay: [...timesheetMonth.timesheetLinesByDay, currentValue] };
        }

        return timesheetMonth;
      });

    return [...timesheetLineMonthAccumulator, { month: month, year: year, totalHours: currentValue.totalHours, timesheetLinesByDay: [currentValue] }];
  }, []);
}
